(function () {
	'use strict';

	angular
	.module('core')
	.controller('toolsCtrl', toolsCtrl);

	toolsCtrl.$inject = ['$http', '$scope', '$rootScope', '$q', '$timeout', '$route'];

	function toolsCtrl($http, $scope, $root, $q, $timeout, $route, $upload) {
		var vm = $scope;

		vm.tool = $route.current.params.tool;
		vm.calculation = {};

		vm.currentOption = {};
		vm.currentCard = {};
		vm.optionDragging = false;
		vm.cardDragging = false;

		vm.data = {
			'cards':[],
			'options':[]
		}

		vm.focus = function(id, event){
			if(!$('#'+id).is(":focus")){
				$('#'+id).trigger('focus');
			}
		}

		vm.upload = function(_files, e) {
			if(_files.length > 0){
				var reader = new FileReader();
				reader.onload = function(t){
					var data = t.target.result;
					data = JSON.parse(atob(data.replace('data:application/json;base64,', '')));
					vm.data = angular.copy(data);
				}
				reader.readAsDataURL(_files[0]);
			}
		}		

		vm.hasDownload = function(){
			return (vm.data.cards.length > 0 && vm.data.options.length > 0);
		}

		vm.download = function(){
			angular.forEach(vm.data.cards, function(card){
				delete card.hover;
			});
			var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(JSON.parse(angular.toJson(vm.data)),null,2));
			var dlAnchorElem = document.getElementById('downloadAnchorElem');
			dlAnchorElem.setAttribute("href",     dataStr     );
			dlAnchorElem.setAttribute("download", "cards.json");
			dlAnchorElem.click();
		}

		vm.deleteOption = function(_opt){
			angular.forEach(vm.data.cards, function(card){
				if(card.options != undefined){
					var _remove = -1;
					angular.forEach(card.options, function(option, index){
						if(angular.equals(option, _opt)){
							_remove = index;
						}
					})

					if(_remove >= 0){
						vm.removeFrom(card.options, _remove);
					}
				}
			})
		}

		vm.addCard = function(){
			if(vm.newCard != '' && vm.newCard != undefined){
				vm.data.cards.push({'title':angular.copy(vm.newCard)});
				vm.newCard = '';
			}
		}

		vm.addOption = function(){
			if(vm.newOption != '' && vm.newOption != undefined){
				vm.data.options.push({'title':angular.copy(vm.newOption)});
				vm.newOption = '';
			}
		}

		vm.checkOption = function(e){
			if(e.key == 'Enter'){
				e.preventDefault();
				vm.addOption();
			}
		}

		vm.checkCard = function(e){
			if(e.key == 'Enter'){
				e.preventDefault();
				vm.addCard();
			}
		}

		vm.cardOver = function(callback, event){
			var item = callback();
			var _scope = angular.element(event.target).scope();
			
			if(_scope.card != undefined){
				var _hover = true;
				angular.forEach(_scope.card.options, function(opt){
					if(angular.equals(opt, item)){
						_hover = false;
					}
				});
				_scope.card.hover = _hover;
				_scope.$apply();
			}
			else {
				angular.forEach(vm.data.cards, function(card){
					card.hover = false;
				})
				vm.$apply();
			}
			return true;
		}

		vm.setOptionDragging = function(_bool){
			vm.optionDragging = _bool;
		}
		vm.setCardDragging = function(_bool){
			vm.cardDragging = _bool;
		}

		vm.setCard = function(item, event, callback){
			item = callback();
			if(item.options == undefined){
				item.options = [];
			}
			var _new = angular.copy(angular.element(event.target).scope().option);
			var _goOn = true;

			angular.forEach(item.options, function(opt){
				if(angular.equals(opt, _new)){
					_goOn = false;
				}
			});
			if(_goOn){
				item.options.push(_new);
			}
		}
		vm.setOption = function(item, event, callback){
			var _scope = angular.element(event.target).scope();
			var card = _scope.card;

			if(card != undefined) {
				if(card.options == undefined) {
					card.options = [];
				}

				var _new = angular.copy(item);
				var _goOn = true;

				angular.forEach(card.options, function(opt){
					if(angular.equals(opt, _new)){
						_goOn = false;
					}
				});
				if(_goOn){
					card.options.push(_new);
				}

				card.hover = false;
			}
		}

		vm.getCard = function(card){
			return card;
		}
		vm.getOption = function(option){
			return option;
		}

		vm.removeFrom = function(list, index){
			list.splice(index, 1);
		}

		vm.updateCalculation = function(){
			var _submissions = parseFloat(vm.responses) / (parseFloat(vm.completion)/100);
			vm.trafficTotal = 5*(_submissions / (parseFloat(vm.trafficPct)/100))/(parseFloat(vm.duration));
			vm.cost = parseFloat(vm.responses) * parseFloat(vm.incentive);
		}

		vm.clearCalculation = function(){
			vm.trafficPct = .1;
			vm.completion = 20;
			vm.responses = 1000;
			vm.incentive = 10;
			vm.duration = 4;

			vm.updateCalculation();
		}

		vm.init = function() {
			vm.clearCalculation();
			$root.loading = false;
		}
		vm.init();
	}
})();